import type {
  GovernmentReportingServiceType,
  ReportingUploadType,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const createGovReportingConfigMutationAtom = createMutationAtomFactory(
  'settings.govReportingConfigCreate',
  (params: {
    serviceType: GovernmentReportingServiceType;
    name: string;
    encryptedCredentials?: string;
    uploadType: ReportingUploadType;
    recyclerId?: string;
    toEmailAddress?: string;
    uploadTimezone?: string;
    daysOfWeek?: Record<string, boolean>;
    processBatchesAsUnit: boolean;
    isActive: boolean;
    fields?: Record<string, unknown>;
  }) => ({
    complianceGovernmentReportingConfigurationCreate: {
      __args: {
        input: {
          serviceType: params.serviceType,
          name: params.name,
          encryptedCredentials: params.encryptedCredentials,
          uploadType: params.uploadType,
          recyclerId: params.recyclerId,
          toEmailAddress: params.toEmailAddress,
          uploadTimezone: params.uploadTimezone,
          daysOfWeek: params.daysOfWeek,
          processBatchesAsUnit: params.processBatchesAsUnit,
          isActive: params.isActive,
          fields: params.fields,
        },
      },
      id: true,
    },
  }),
);
